<div *ngIf="getWithPlacement()">
  <mat-card class="top-card mat-elevation-z0 no-padding overflowHidden">
    <div
      [class.collapsed]="isCollapsed"
      class="section-header padding d-flex  overflowHidden clickable"
      (click)="toggleCollapsed()"
      [attr.aria-expanded]="!isCollapsed"
    >
      <div class="projectTitle flexer">
        {{ productTypeDisplay }}
        <span>#{{ index + 1 }}</span>
        <span
          *ngIf="inputProduct?.productPlacement?.executionComplete"
          class="font-weight-normal red"
        >
          - uitgevoerd{{ executionDateDisplay }}
        </span>
      </div>
      <button
        mat-icon-button
        class="arrow-button pull-right"
        style="margin-top:5px"
      >
        <mat-icon svgIcon="arrow-up"></mat-icon>
      </button>
    </div>
    <div [collapse]="isCollapsed" [isAnimated]="!safari">
      <ng-container *ngIf="renderChildren | async">
        <windowsticker-placement-form
          *ngIf="isWindowSticker() || isCustomWindowsticker()"
          [inputProject]="this.inputProject"
          [inputProduct]="inputWindowsticker"
          [inputProjectPlacement]="inputProject.projectPlacement"
          (outputProduct)="outputProduct.emit()"
        >
        </windowsticker-placement-form>
        <board-placement-form
          *ngIf="isBoard()"
          [inputProject]="this.inputProject"
          [inputProduct]="inputBoard"
          [inputProjectPlacement]="inputProject.projectPlacement"
          (outputProduct)="outputProduct.emit()"
        ></board-placement-form>
        <other-product-placement-form
          *ngIf="isOtherProduct()"
          [inputProject]="this.inputProject"
          [inputProduct]="inputOtherProduct"
          [inputProjectPlacement]="inputProject.projectPlacement"
          (outputProduct)="outputProduct.emit()"
        ></other-product-placement-form>
      </ng-container>
    </div>
  </mat-card>
</div>
